export const categoryPillClassName = "bg-indigo-100 text-indigo-800 border border-indigo-200 px-2 py-1 text-sm flex items-center gap-1";

export const categoryPillRemoveClassName = "text-indigo-700 hover:text-indigo-900";

export const areaPillClassName = "bg-emerald-100 text-emerald-800 border border-emerald-200 px-2 py-1 text-sm flex items-center gap-1";

export const areaPillRemoveClassName = "text-emerald-700 hover:text-emerald-900";